import { ContactRemovalTriggerEnum } from '@ben/api/gen/codegen.schemas';

export const removalTriggerOptions = [
  {
    key: ContactRemovalTriggerEnum.END_OF_POLICY_YEAR,
    label: 'End of policy year',
  },
  {
    key: ContactRemovalTriggerEnum.DAY_BEFORE_BIRTHDAY,
    label: 'Day before birthday',
  },
  { key: ContactRemovalTriggerEnum.ON_BIRTHDAY, label: 'On birthday' },
  {
    key: ContactRemovalTriggerEnum.END_OF_BIRTHDAY_MONTH,
    label: 'End of birthday month',
  },
];
